import axios from 'axios'
import io from 'socket.io-client'
import uuid from 'uuid'
import NProgress from 'nprogress'
import './nprogress.css'

NProgress.configure({
  minimum: 0.08,
  easing: 'ease',
  positionUsing: '',
  speed: 200,
  trickle: true,
  trickleRate: 0.015,
  trickleSpeed: 350,
  showSpinner: false,
  barSelector: '[role="bar"]',
  spinnerSelector: '[role="spinner"]',
  parent: 'body',
  template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
})

// let analytics = 'https://yo-analytics.herokuapp.com'

// // debug
// if (process.env.NODE_ENV === 'development') {
//   analytics = 'http://localhost:1337'
// }

export const OPTIONS = {
  log: false,
  // analytics,
  marker: '',
  userData: false
}

export var baseURL = 'http://localhost:3000/'

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://yoteach-cloud.herokuapp.com/'
} else if (window.location.host.indexOf('192') !== -1) {
  baseURL = 'http://' + window.location.hostname + ':3000/'
}

// debug
baseURL = `https://yoteach-cloud.herokuapp.com/`

export const PROXY_URL = baseURL + 'yo/proxy'

export var iAXIOS = null

let makeAxios = () => {
  let config = {
    withCredentials: true,
    headers: {},
    baseURL
  }
  let rememberMe = window.localStorage.getItem('jwt_remember_me')
  if (rememberMe) {
    config.headers = {
      'Authorization': `bearer ${rememberMe}`
    }
  }

  iAXIOS = axios.create(config)

  iAXIOS.interceptors.request.use((config) => {
    // Do something before request is sent
    NProgress.start()
    return config
  }, (error) => {
    NProgress.done()
    // Do something with request error
    return Promise.reject(error)
  })

  // Add a response interceptor
  iAXIOS.interceptors.response.use((response) => {
    NProgress.done()
    // Do something with response data
    return response
  }, (error) => {
    NProgress.done()
    // Do something with response error
    return Promise.reject(error)
  })
}
makeAxios()

// sockets....

var _sockets = []
var makeSocket = (path) => {
  // return io(`${baseURL}/${path}`, { transports: ['websocket'] })
  let socket = io(`${baseURL}${path}`, { transports: ['websocket'] })
  window.addEventListener('focus', () => {
    socket.connect()
  })
  _sockets.push(socket)
  return socket
}

export const sockets = {
  makeSocket,
  get list () {
    return _sockets
  }
}

function prepSocket () {
  try {
    sockets.yoteach = makeSocket('yoteach')
  } catch (e) {
    setTimeout(() => {
      prepSocket()
    }, 1000 * 10)
  }
}
prepSocket()

export const makeSessionForRoom = ({ roomID }) => {
  var MEMORY_DB = {}
  const ss = {
    getItem (key) {
      return MEMORY_DB[key]
    },
    setItem (key, value) {
      MEMORY_DB[key] = value
    }
  }
  let api = {
    addAdmin ({ roomID, roomAdminPassword, uuid }) {
      return addAdmin({ roomID, roomAdminPassword, uuid })
    },
    removeAdmin ({ roomID, roomAdminPassword, uuid }) {
      return removeAdmin({ roomID, roomAdminPassword, uuid })
    },
    login ({ roomAdminPassword }) {
      return checkRoomAdminPW({ roomID, roomAdminPassword })
        .then(() => {
          api.roomPassword = roomAdminPassword
        }, () => {
          api.roomPassword = ''
          return Promise.reject(new Error('bad pw'))
        })
    },
    logout () {
      api.roomPassword = ''
      return Promise.resolve()
    },
    hasPW () {
      let localPW = ss.getItem('roomPassword' + roomID)
      return !!localPW && localPW !== '' && typeof localPW === 'string'
    },
    get roomPassword () {
      return ss.getItem('roomPassword' + roomID)
    },
    set roomPassword (v) {
      return ss.setItem('roomPassword' + roomID, v)
    }
  }
  return api
}

export const checkOnline = ({ roomID }) => {
  sockets.yoteach.emit('up/keep/check-online', { roomID })
}

export const joinKeepRoom = ({ roomID, nickname, deviceID }) => {
  sockets.yoteach.emit('up/keep/join', {
    roomID,
    nickname,
    deviceID
  })
}

export const leaveKeepRoom = ({ roomID }) => {
  sockets.yoteach.emit('up/keep/leave', { roomID })
}

export const onChangeOnlineCounter = ({ roomID, onChange = () => {} }) => {
  sockets.yoteach.on('dn/online-room-user-count', (data) => {
    if (roomID === data.roomID) {
      onChange(data)
    }
  })
}

export const onMessageChange = ({ roomID, add, remove, update, goLogin = () => {} }) => {
  sockets.yoteach.on('dn/message-add', (data) => {
    // console.log(roomID, data)
    if (roomID === data.roomID) {
      add(data)
    }
  })

  sockets.yoteach.on('dn/message-remove', (data) => {
    if (roomID === data.roomID) {
      remove(data)
    }
  })

  sockets.yoteach.on('dn/message-update', (data) => {
    if (roomID === data.roomID) {
      update(data)
    }
  })

  sockets.yoteach.on('dn/go-login', () => {
    goLogin()
  })
}

export const onRoomChange = ({ roomID, update, goHome, onClearRoom }) => {
  sockets.yoteach.on('dn/room-refresh', (data) => {
    if (roomID === data._id) {
      update(data)
    }
  })
  sockets.yoteach.on('dn/room-remove-messages', (data) => {
    if (roomID === data._id) {
      onClearRoom(data)
    }
  })
  sockets.yoteach.on('dn/room-remove', (data) => {
    if (roomID === data._id) {
      goHome()
    }
  })
}

export const refreshPool = (data) => {
  return new Promise((resolve, reject) => {
    sockets.yoteach.emit('up/poll-refresh', data, (cbVal) => {
      resolve(cbVal)
    })
  })
}

export const onPoolRefresh = (handler) => {
  sockets.yoteach.on('dn/poll-refresh', handler)
}

export const removeRoom = (data) => {
  sockets.yoteach.emit('up/room-remove', data)
}

export const clearAllRoomMessages = (data) => {
  sockets.yoteach.emit('up/room-remove-messages', data)
}

export const roomChanged = (data) => {
  sockets.yoteach.emit('up/room-refresh', data)
}

export const messageChanged = (data) => {
  sockets.yoteach.emit('up/message-update', data)
}

export const messageDeleted = (data) => {
  sockets.yoteach.emit('up/message-deleted', data)
}

export const joinRoom = (data) => {
  sockets.yoteach.emit('up/join', data)
}

export const translateMessage = (data) => {
  return iAXIOS.post(`/yo/translate`, data)
}

export const likeMessage = (data) => {
  return iAXIOS.post(`/yo/messages/likeMessage`, data)
}

export const unlikeMessage = (data) => {
  return iAXIOS.post(`/yo/messages/unlikeMessage`, data)
}

export const getRoom = (data) => {
  return iAXIOS.get(`/yo/rooms/${data._id}`)
}

export const checkRoomEntryPW = (data) => {
  return iAXIOS.post('/yo/rooms/checkRoomEntryPW', data)
}

export const checkRoomNameTaken = (data) => {
  return iAXIOS.post('/yo/rooms/checkRoomNameTaken', data)
}

export const checkRoomAdminPW = (data) => {
  return iAXIOS.post('/yo/rooms/checkRoomAdminPW', data)
}

export const checkRoomAdminPWRecoveryAns = (data) => {
  return iAXIOS.post('/yo/rooms/checkRoomAdminPWRecoveryAns', data)
}

export const checkCanRecoverAdminPW = (data) => {
  return iAXIOS.post('/yo/rooms/checkCanRecoverAdminPW', data)
}

export const resetRoomAdminPW = (data) => {
  return iAXIOS.post('/yo/rooms/resetRoomAdminPW', data)
}

export const createRoom = (data) => {
  return iAXIOS.post('/yo/rooms', data)
}

export const getRoomDetails = (data) => {
  return iAXIOS.post('/yo/getRoomDetails', data)
}

export const countRooms = (data) => {
  return iAXIOS.post('/yo/rooms/countRooms', data)
}

export const findMessage = (data) => {
  return iAXIOS.post('/yo/messages/find', data)
}

export const getGoodAsk = (data) => {
  return iAXIOS.post('/yo/messages/getGoodAsk', data)
}

export const getAllAsk = (data) => {
  return iAXIOS.post('/yo/messages/getAllAsk', data)
}

export const setGoodAsk = (data) => {
  return iAXIOS.post('/yo/messages/setGoodAsk', data)
}

export const setPinned = (data) => {
  return iAXIOS.post('/yo/messages/setPinned', data)
}

export const deleteOneMessage = (data) => {
  return iAXIOS.post('/yo/messages/deleteOneMessage', data)
}

export const switchRoomMode = (data) => {
  return iAXIOS.post('/yo/rooms/switchRoomMode', data)
}

export const getMessageOfDay = (data) => {
  return iAXIOS.post('/yo/messages/ofDay', data)
}

export const addAdmin = (data) => {
  return iAXIOS.post('/yo/rooms/addAdmin', data)
}

export const removeAdmin = (data) => {
  return iAXIOS.post('/yo/rooms/removeAdmin', data)
}

export const addMute = (data) => {
  return iAXIOS.post('/yo/rooms/addMute', data)
}

export const removeMute = (data) => {
  return iAXIOS.post('/yo/rooms/removeMute', data)
}

export const searchRoom = (data) => {
  return iAXIOS.post('/yo/rooms/search', data)
}

export const listFeaturedRooms = () => {
  return iAXIOS.get('/yo/rooms/featured')
}

export const getIdByTitle = (data) => {
  return iAXIOS.post('/yo/rooms/getIDByTitle', data)
}

export const getAllMessageOfRoom = (data) => {
  return iAXIOS.post('/yo/messages/getAllMessageOfRoom', data)
}

export const scanMessage = (data) => {
  return iAXIOS.post('/yo/scanMessage', data)
}

export const activateUser = (data) => {
  return iAXIOS.post('/yo/activate-user', data)
}

// ---------

export const getPageByYoRoomID = (data) => {
  return iAXIOS.post('/yo/page/getPageByYoRoomID', data)
}

export const createSecurePage = (data) => {
  return iAXIOS.post('/yo/page/createSecurePage', data)
}

export const deleteOnePageWithPassword = (data) => {
  return iAXIOS.post('/yo/page/deleteOnePageWithPassword', data)
}

export const updatePageSecure = (data) => {
  return iAXIOS.post('/yo/page/updatePageSecure', data)
}

// ----------

export const createSecurePoll = (data) => {
  return iAXIOS.post('/yo/poll/createSecure', data)
}

export const getPollByYoMessageID = (data) => {
  return iAXIOS.post('/yo/poll/getPollByYoMessageID', data)
}

export const updatePollSecure = (data) => {
  return iAXIOS.post('/yo/poll/updatePollSecure', data)
}

export const tryAddVoteToPoll = (data) => {
  return iAXIOS.post('/yo/poll/tryAddVoteToPoll', data)
}

export const tryRemoveVoteFromPoll = (data) => {
  return iAXIOS.post('/yo/poll/tryRemoveVoteFromPoll', data)
}

export const remakeAndGetLatestPin = (data) => {
  return iAXIOS.post('/yo/rooms/remakeAndGetLatestPin', data)
}

export const checkPin = (data) => {
  return iAXIOS.post('/yo/rooms/checkPin', data)
}

export const getLatestPin = (data) => {
  return iAXIOS.post('/yo/rooms/getLatestPin', data)
}
export const findOneMessage = (data) => {
  return iAXIOS.post('/yo/messages/findOne', data)
}

// export const tryLogWhenOkay = async (v) => {
//   if (OPTIONS.log && OPTIONS.marker === 'buhk') {
//     let msgResp = {}
//     if (v.parentID) {
//       try {
//         msgResp = await findOneMessage({ _id: v.parentID })
//         console.log('reply', msgResp.data)
//       } catch (e) {
//         console.log(e)
//       }
//     }
//     return axios({
//       baseURL: OPTIONS.analytics,
//       method: 'post',
//       data: {
//         playerID: OPTIONS.userData.userID,
//         msgRaw: v,
//         msgReplyRaw: msgResp.data,
//         logDate: new Date(),
//         isReply: !!v.parentID,
//         replyToMessageID: v.parentID || '',
//         messageID: v._id
//       },
//       url: '/yoteaches'
//     })
//   } else {
//     return Promise.reject(new Error('cant log msg'))
//   }
// }

export const sendMessage = (data) => {
  return new Promise(async (resolve, reject) => {
    // let resp = await me()
    // let myUserID = resp.data._id
    // data.userID = myUserID
    // console.log(data)
    sockets.yoteach.emit('up/message-add', data, (v) => {
      resolve(v)
      console.log('msg', v)
      // tryLogWhenOkay(v)
    })
  })
}

export const activateAdmin = (data) => {
  return iAXIOS.post('/activateAdminRole', data)
}

export const removeMessage = (data) => {
  return new Promise((resolve, reject) => {
    sockets.yoteach.emit('up/message-remove', data, () => {
      resolve()
    })
  })
}

export const listSomeLatest = (data) => {
  return iAXIOS.post('/yo/messages/latest', data)
}
export const listWordCloudMessages = (data) => {
  return iAXIOS.post('/yo/messages/wordcloud', data)
}

export const refresh = () => {
  sockets.list.forEach((s) => {
    s.disconnect()
    console.log('disconnecting')
    setTimeout(() => {
      s.connect()
      console.log('connecting')
    }, 500)
  })
  Status.loadUser()
}

// login
export const login = (data) => {
  return iAXIOS.post('/yo/login', data)
    .then((resp) => {
      refresh()
      return resp
    }, (err) => {
      console.log(err)
      logout().then(() => {
        refresh()
      })
      return err
    })
}

export const signS3 = (data) => {
  return iAXIOS.post('/yo/signS3', data)
}

export const check = () => {
  return me().then((resp) => {
    let data = resp.data
    if (typeof data === 'object') {
      return Promise.resolve('ok')
    } else if (data === false) {
      return Promise.reject(new Error('no login'))
    } else {
      return Promise.reject(new Error('no login'))
    }
  }, () => {
    return Promise.reject(new Error('no login'))
  })
}

export const isAdmin = () => {
  return me().then((resp) => {
    let data = resp.data.roles.indexOf('admin') !== -1
    if (data === true) {
      return Promise.resolve(true)
    } else if (data === false) {
      return Promise.reject(new Error('no login'))
    } else {
      return Promise.reject(new Error('no login'))
    }
  }, () => {
    return Promise.reject(new Error('no login'))
  })
}

// logout
export const logout = (data) => {
  return iAXIOS.post('/yo/logout', data)
    .then((resp) => {
      Status.state.user = false
      return resp
    }, (err) => {
      Status.state.user = false
      return err
    })
}

export const me = () => {
  return iAXIOS.get('/yo/me')
}

export const SYS = () => {
  var state = {
    // pw temp vault
    tempPW: {},
    favRooms: [],
    chatter: false,
    user: false
  }
  var api = {
    state
  }

  // var loadUser = api.loadUser = () => {
  api.loadUser = () => {
    return me()
      .then((resp) => {
        state.user = resp.data
        return resp
      }, () => {
        state.user = false
        return logout()
      })
      .then(() => {
        console.log(state)
      })
  }

  var loadChatter = api.loadChatter = () => {
    let ls = window.localStorage
    // let setStuff = window.localStorage.setItem
    let ns = 'yo/chatter'
    let hasChatter = ls.getItem(ns)
    if (hasChatter) {
      try {
        state.chatter = JSON.parse(ls.getItem(ns))
      } catch (e) {
        console.log(e)
      }
    }
  }

  api.setChatter = ({ chatter }) => {
    // let getStuff = window.localStorage.getItem
    let ls = window.localStorage
    let ns = 'yo/chatter'

    let hasChatter = !!ls.getItem(ns)

    let newInfo = {
      ...chatter
    }

    if (hasChatter) {
      let oldInfo = JSON.parse(ls.getItem(ns))
      newInfo = {
        ...newInfo,
        uuid: oldInfo.uuid,
        name: newInfo.name
      }
    } else {
      newInfo = {
        ...newInfo,
        uuid: uuid.v4()
      }
    }

    ls.setItem(ns, JSON.stringify(newInfo))
    state.chatter = JSON.parse(ls.getItem(ns))
  }

  var loadFavRooms = api.loadFavRooms = () => {
    let ls = window.localStorage
    // let setStuff = window.localStorage.setItem
    let ns = 'yo/favRooms'
    let hasFavRooms = ls.getItem(ns)
    if (hasFavRooms) {
      try {
        state.favRooms = JSON.parse(ls.getItem(ns)) || []
      } catch (e) {
        console.log(e)
      }
    }
  }

  api.addFavRoom = ({ favRoom }) => {
    let ls = window.localStorage
    let ns = 'yo/favRooms'
    let hasFavRooms = ls.getItem(ns)
    if (!hasFavRooms) {
      state.favRooms = []
    }
    if (state.favRooms.findIndex(i => i._id === favRoom._id) === -1) {
      state.favRooms.push(favRoom)
    }
    ls.setItem(ns, JSON.stringify(state.favRooms))
  }

  api.removeFavRoom = ({ favRoom }) => {
    let ls = window.localStorage
    let ns = 'yo/favRooms'
    let hasFavRooms = ls.getItem(ns)
    if (!hasFavRooms) {
      state.favRooms = []
    }
    let idx = state.favRooms.findIndex(i => i._id === favRoom._id)
    if (idx !== -1) {
      state.favRooms.splice(idx, 1)
    }
    ls.setItem(ns, JSON.stringify(state.favRooms))
    console.log('remove fav room')
  }

  loadFavRooms()
  loadChatter()
  // loadUser()
  return api
}

export const Status = SYS()
